import { useState, useEffect, useRef } from "react";
import { User, Wallet, RotateCw, X, Calendar, LogOut, Settings, ChevronDown } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { logoutUser, selectCurrentUser } from "../features/auth/authSlice";
import CurFt from "./CurFt";
import { fetchWalletbalance, DoDepositRequest, clearDepositError } from "../features/wallet/walletSlice";
import { Dialog } from "@headlessui/react";
import { DateInput } from "@mantine/dates";
import { toast } from "react-hot-toast";
import { usePaymentProcessRecharge } from "../services/usePaymentProcessRecharge";
import WalletUtils from "../utils/walletUtils";
import { getSiteName, getdomainFullURL, getdomainName, getapiKey, getcrmbaseURL } from "../api/axios";
import { NavLink } from "react-router-dom";
import { format, parseISO } from "date-fns";
import { TruncatedText } from "./TruncatedText";


const Navbar = () => {
  const location = useLocation();
  const segments = location.pathname.split("/").filter(Boolean);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showHoliday, setShowHoliday] = useState(false);
  const [showFinance, setShowFinance] = useState(false);
  const [showNotif, setShowNotif] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [newBalance, setNewBalance] = useState(0);
  const [newBNPLBalance, setnewBNPLBalance] = useState(0);
  const dropdownRef = useRef(null);
  const { walletbalanceStatus, walletbalanceData, depositStatus, depositData } = useSelector((state) => state.wallet);
  const { logoutstatus } = useSelector((state) => state.auth);

  const user = useSelector(selectCurrentUser);
  const [response, setResponse] = useState(user);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate("/");
  };

  const closeDropdowns = () => {
    setShowNotif(false);
    setShowHoliday(false);
    setShowFinance(false);
    setShowProfile(false);
  };
  const [DueClearMessage, setDueClearMessage] = useState('');
  useEffect(() => {
    setResponse(user)
    setFormData((prev) => ({
      ...prev,
      ['customer_id']: (user?.UserData?.user?.UserType === 7) ? user?.UserData?.user?.UserSysId : user?.UserData?.id
    }));
    const today = new Date();
    // const targetDate = new Date("2026-01-11");
    const targetDate = new Date(user?.UserData?.DueDate);
    if (today > targetDate && user.UserData.totalOutStanding > 0) {
      setIsModalSector(true)
      setDueClearMessage('Your credit limit due date has been exceeded. Kindly settle the outstanding balance at the earliest to avoid service disruption.')
    }
  }, [user]);
  useEffect(() => {
    if (walletbalanceStatus === true && walletbalanceData?.status?.success === true) {
      setIsRotating(false);
      let newBalance = walletbalanceData.balances.bookable_balance || 0;
      let totalOutStanding = walletbalanceData.balances.totalOutStanding || 0;
      let DueDate = walletbalanceData.balances.DueDate || null;
      let newBNPL = walletbalanceData.balances?.BNPL || {};
      let newBNPLBalance = walletbalanceData?.balances?.BNPL?.available_credit_sum || 0;

      setNewBalance(newBalance);
      setnewBNPLBalance(newBNPLBalance);
      setResponse((prev) => ({
        ...prev,
        UserData: {
          ...prev.UserData,
          accountBalance: newBalance, // ✅ overwrite only this
          totalOutStanding: totalOutStanding, // ✅ overwrite only this
          DueDate: DueDate, // ✅ overwrite only this
          BNPL: newBNPL, // ✅ overwrite only this
        },
      }));
    }
  }, [walletbalanceStatus, walletbalanceData]);
  useEffect(() => {
    if (newBalance >= 0) {
      localStorage.setItem("user", JSON.stringify(response));
    }
  }, [response, newBalance, newBNPLBalance]);

  useEffect(() => { }, [logoutstatus]);

  useEffect(() => {
    document.addEventListener("click", closeDropdowns);
    return () => document.removeEventListener("click", closeDropdowns);
  }, []);
  // console.log(user?.UserData?.user.agency);
  // Dynamic dropdown items
  const financeMenu = [
    { name: "Ledger", path: "/finance/ledger" },
    { name: "Deposit Request", path: "/finance/deposit-request" },
    { name: "Withdrawal Request", path: "/finance/withdrawal-request" },
    ...(user?.UserData?.user?.UserType === 6
      ? [{ name: "Discount & Commission", path: "/finance/commission" },
      { name: "Commission Ledger", path: "/finance/commission-ledger" }]
      : []),
  ];

  const reportMenu = [
    { name: "Flight Tickets", path: "/booking-calendar" },
    ...(user?.UserData?.user?.agency?.bnpl_allowed === 1
      ? [{ name: "BNPL Due Report", path: "/report/bnpl-due-report" }]
      : []),
    { name: "Amendment Request", path: "/report/amendment-request" },
    { name: "Group Request", path: "/report/group-request" },
    { name: "Hotel Bookings", path: "/hotel/booking-calender" },
    { name: "Holiday Bookings", path: "/Holidays/booking-calender" },
    ...(user?.UserData?.user?.agency?.passport_allowed === 1
      ? [{ name: "Passport Request", path: "/passport-request" }]
      : []),
    // { name: "Passport Request", path: "/passport-request" },
  ];

  const [isRotating, setIsRotating] = useState(false);

  const handleRotate = () => {
    setIsRotating(true);
    const balanceReq = {
      customer_id: user?.UserData?.user?.id,
    };
    dispatch(fetchWalletbalance({ balanceReq }));
  };
  const [activeDropdown, setActiveDropdown] = useState(null);
  const toggleDropdown = (menu) => {
    setActiveDropdown(activeDropdown === menu ? null : menu);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [isSectorModalOpen, setIsModalSector] = useState(false);
  const [loading, setloading] = useState(false);

  const [errorMessageRecharge, SetErrorMessageRecharge] = useState("loading");
  const [paymentHookStatusRecharge, setpaymentHookStatusRecharge] = useState(null);
  const [ResponseData, SetResponseData] = useState(null);
  const { handleProceedRecharge } = usePaymentProcessRecharge({
    SetErrorMessageRecharge: SetErrorMessageRecharge,
    setpaymentHookStatusRecharge: setpaymentHookStatusRecharge,
    SetResponseData: SetResponseData,
  });

  const paymentmode = [
    "Make Online",
    "Cash",
    "Bank Transfer",
    "Bank Remittance",
    "Cheque",
    "Credit Card",
    "UPI",
    "Recharge",
  ];
  const RechargeHand = (event) => {
    setIsModalSector(true);
    setFormData((prev) => ({
      ...prev,
      ["referenceno"]: "REF" + Date.now(),
    }));
  };
  // console.log(user?.UserData?.user?.agency?.flight_allowed);


  const [formData, setFormData] = useState({
    customer_id: (user?.UserData?.user?.UserType === 7) ? user?.UserData?.user?.UserSysId : user?.UserData?.id,
    PaymentMode: "Make Online",
    amount: 0,
    referenceno: "REF" + Date.now(),
    date: new Date(),
    remarks: "Wallet TopUp",
    receipt: null,
  });
  const handleChange = (eOrName: any, value?: any) => {
    if (typeof eOrName === "string") {
      // Case: custom components like DateInput
      setFormData((prev) => ({
        ...prev,
        [eOrName]: value,
      }));
    } else {
      // Case: normal <input />, <select />, etc.
      const e = eOrName;
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let txnid = "TXN" + Date.now();
    const hash = WalletUtils.walletCode(
      txnid,
      txnid,
      parseFloat(formData?.amount).toFixed(2),
      user?.UserData?.name,
      user?.UserData?.mobile,
      user?.UserData?.email,
      "Wallet Recharge"
    );
    const customerInfo = {
      txnid: txnid,
      amount: parseFloat(formData?.amount).toFixed(2),
      name: user?.UserData?.name,
      email: user?.UserData?.email,
      phone: user?.UserData?.mobile,
      productinfo: "Wallet Recharge",
      surl: getdomainFullURL() + "/payment/payment-success?planType=4&BookingID=" + formData.referenceno,
      // surl: getcrmbaseURL() + "api/payment/response?token=" + user?.token,
      furl: getdomainFullURL() + "/payment/payment-success?planType=4&BookingID=" + formData.referenceno,
      udf1: formData.referenceno,
      udf2: "4",
      udf3: "Web-B2B",
      udf4: (user?.UserData?.user?.UserType === 7) ? user?.UserData?.user?.UserSysId : user?.UserData?.user?.id, // customer id
      udf5: user?.UserData?.user?.AgencyID,
      udf6: "INR",
      udf7: "recharge",
      udf8: "",
      udf9: "",
      udf10: "",
      securecode: hash,
    };
    if (formData.amount === 0) {
      toast.error("Amount can not be ZERO", { autoClose: 2000 });
      return false;
    }
    if (formData.amount < 1) {
      toast.error("Amount should be greater than qual to 1", { autoClose: 2000 });
      return false;
    }
    if (formData.referenceno === "") {
      toast.error("Enter your reference no", { autoClose: 2000 });
      return false;
    }
    if (formData.date === "" || formData.date === null) {
      toast.error("Enter your Deposit Date", { autoClose: 2000 });
      return false;
    }
    if (formData.remarks === "") {
      toast.error("Enter your remarks", { autoClose: 2000 });
      return false;
    }

    if (formData.PaymentMode === "Make Online") {
      setloading(true);
      handleProceedRecharge(customerInfo);
    } else {
      setloading(true);
      const payload = new FormData();

      Object.keys(formData).forEach((key) => {
        if (key === "date") {
          const formattedDate = format(new Date(formData.date), "yyyy-MM-dd");
          payload.append("date", formattedDate);
        } else {
          payload.append(key, formData[key]);
        }
      });

      dispatch(clearDepositError());
      dispatch(DoDepositRequest(payload)).unwrap();
    }
    setloading(false);
  };

  useEffect(() => {
    setTimeout(() => {
      if (paymentHookStatusRecharge === "success" && ResponseData.udf7 === "recharge") {
        setIsModalSector(false);
        setloading(false);
        setIsRotating(true);
        const balanceReq = {
          customer_id: user?.UserData?.user?.id,
        };
        dispatch(fetchWalletbalance({ balanceReq }));
        toast.success("Wallet top-up successful", { autoClose: 4000 });
      } else if (paymentHookStatusRecharge === "paymentfailed" && ResponseData.udf7 === "recharge") {
        setIsModalSector(false);
        setloading(false);
        SetErrorMessageRecharge("paymentfailed");
        toast.error("Wallet top-up failed. plese contact with support team.", { autoClose: 4000 });
      }
    }, 3000);
  }, [paymentHookStatusRecharge, errorMessageRecharge]);

  useEffect(() => {
    if (depositStatus === true && depositData?.status?.success === true) {
      setIsModalSector(false);
      setloading(false);
      toast.success("Deposit request created successfully", { autoClose: 4000 });
    } else if (paymentHookStatusRecharge === "paymentfailed") {
      SetErrorMessageRecharge("paymentfailed");
      setloading(false);
    } else if (depositData) {
      toast.error(depositData?.message || 'paymentfailed', { autoClose: 4000 });
    }
  }, [depositStatus, depositData]);
  const handleInput = (e) => {
    if (e.target.name === "amount") {
      if (e.target.value.length > 7) {
        e.target.value = e.target.value.slice(0, 7);
      }
    }
  };
  const [showRM, setShowRM] = useState(false);

  const openRelationshipManager = () => setShowRM(true);
  const closeRelationshipManager = () => setShowRM(false);
  const [fileName, setFileName] = useState("");
  const handlePhotoChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    // ✅ Allowed types
    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ];

    // ✅ Validate type
    if (!allowedTypes.includes(file.type)) {
      alert("Only JPG, JPEG, PNG, and PDF files are allowed.");
      e.target.value = "";
      return;
    }

    // ✅ Validate size (5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      alert("File size must be less than 5MB.");
      e.target.value = "";
      return;
    }

    // ✅ Set in formData
    setFormData((prev) => ({
      ...prev,
      receipt: file,
    }));

    // ✅ Store file name for UI
    setFileName(file.name);
  };
  const fileInputRef = useRef(null);
  const handleRemoveFile = () => {
    setFormData((prev) => ({
      ...prev,
      receipt: null,
    }));

    setFileName("");

    // Reset file input
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const [showPass, setShowPass] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navLinks = ["Home", "About Us", "Agent", "White Label", "API/XML", "Supplier", "Contact Us"];
  return (
    <>
      {user?.UserData ? (
        <>
          {showRM && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
              <div className="w-full max-w-sm rounded-lg bg-white shadow-lg p-5">

                {/* Header */}
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-lg font-semibold">
                    Relationship Manager
                  </h2>
                  <button
                    onClick={closeRelationshipManager}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    ✕
                  </button>
                </div>

                {/* Content */}
                <div className="text-sm text-gray-600">
                  <p>Name: {user.UserData.user?.details?.r_m_user?.title} {user.UserData.user?.details?.r_m_user?.name}</p>
                  <p>Email: {user.UserData.user?.details?.r_m_user?.email}</p>
                  <p>Mobile: {user.UserData.user?.details?.r_m_user?.mobile}</p>
                </div>

                {/* Footer */}
                <div className="mt-4 text-right">
                  <button
                    onClick={closeRelationshipManager}
                    className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}
          <header className="bg-white shadow sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="flex justify-between items-center h-16">
                <div className="flex items-center space-x-8">
                  <span className="text-xl font-bold text-blue-600">
                    <Link to="/">
                      {user?.UserData?.user?.details?.logo ? (
                        <img
                          src={user?.UserData?.user?.details?.logo}
                          alt={user?.UserData?.name}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/default.png";
                          }}
                          style={{ height: "55px", width: "auto" }}
                          className="object-contain"
                        />
                      ) : (
                        <img
                          src={"/" + getSiteName() + "/logo.png"}
                          alt={user?.UserData?.name}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `/${getSiteName()}/logo.png`;
                          }}
                          style={{ height: "55px", width: "auto" }}
                          className="object-contain"
                        />
                      )}
                    </Link>
                  </span>

                  {/* Desktop Nav */}
                  <nav className="hidden md:flex space-x-6" ref={dropdownRef}>
                    {user?.UserData?.user?.agency?.flight_allowed === 1 && (
                      <NavLink
                        to="/flight"
                        className={({ isActive }) =>
                          `font-semibold px-2 ${isActive ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-600"}`
                        }
                      >
                        Flight
                      </NavLink>
                    )}
                    {user?.UserData?.user?.agency?.hotel_allowed === 1 && (
                      <NavLink
                        to="/hotel"
                        className={({ isActive }) =>
                          `font-semibold px-2 ${isActive ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-600"}`
                        }
                      >
                        Hotel
                      </NavLink>
                    )}
                    {user?.UserData?.user?.agency?.holidays_allowed === 1 && (
                      <NavLink
                        to="/Holidays"
                        className={({ isActive }) =>
                          `font-semibold px-2 ${isActive ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-600"}`
                        }
                      >
                        Holidays
                      </NavLink>
                    )}
                    {getdomainName() === 'goertrip.club' && (
                      <NavLink
                        to="/Holidays/umrah"
                        className={({ isActive }) =>
                          `font-semibold px-2 ${isActive ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-600"}`
                        }
                      >
                        Umrah/Hajj
                      </NavLink>
                    )}
                    {user?.UserData?.user?.agency?.passport_allowed === 1 && (
                      <NavLink
                        to="/passport"
                        className={({ isActive }) =>
                          `font-semibold px-2 ${isActive
                            ? "text-blue-600 border-b-2 border-blue-600"
                            : "text-gray-600"
                          }`
                        }
                      >
                        Passport
                      </NavLink>
                    )}


                    {/* Finance Dropdown */}
                    <div className="relative">
                      <button
                        onClick={() => toggleDropdown("finance")}
                        className="hover:text-blue-600 inline-flex items-center"
                      >
                        Finance
                        <svg className="ml-1 h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path d="M19 9l-7 7-7-7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </button>

                      {activeDropdown === "finance" && (
                        <div className="absolute left-0 mt-2 bg-white shadow-lg rounded-md py-2 z-[70] w-auto min-w-max">
                          {financeMenu.map((item, idx) => (
                            <Link
                              onClick={setActiveDropdown}
                              key={idx}
                              to={item.path}
                              className="block px-4 py-2 hover:bg-gray-100 whitespace-nowrap"
                            >
                              {item.name}
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Report Dropdown */}
                    <div className="relative">
                      <button
                        onClick={() => toggleDropdown("report")}
                        className="hover:text-blue-600 inline-flex items-center"
                      >
                        Report
                        <svg className="ml-1 h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path d="M19 9l-7 7-7-7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </button>

                      {activeDropdown === "report" && (
                        <div className="absolute left-0 mt-2 bg-white shadow-lg rounded-md py-2 z-50 w-auto min-w-max">
                          {reportMenu.map((item, idx) => (
                            <Link
                              onClick={setActiveDropdown}
                              key={idx}
                              to={item.path}
                              className="block px-4 py-2 hover:bg-gray-100 whitespace-nowrap"
                            >
                              {item.name}
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* <Link to="/booking-calendar" className="hover:text-blue-600">Flight Tickets</Link> */}
                  </nav>
                </div>

                {/* Right Icons */}
                <div className="flex items-center space-x-4">
                  {/* Notifications */}
                  {/* <div className="relative" onClick={(e) => e.stopPropagation()}>
              <button onClick={() => setShowNotif(!showNotif)} className="relative">
                <svg className="h-6 w-6 text-gray-700" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 01-6 0v-1m6 0H9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span className="absolute -top-1 -right-1 h-2 w-2 bg-red-500 rounded-full"></span>
              </button>
              {showNotif && (
                <div className="absolute right-0 mt-2 w-64 bg-white shadow-lg rounded-md z-50 text-sm p-4">
                  <p className="font-medium">Notifications</p>
                  <ul className="mt-2 space-y-2">
                    <li><a href="#" className="text-blue-600 hover:underline">✈️ New flight booking received</a></li>
                    <li><a href="#" className="text-blue-600 hover:underline">⚠️ Credit balance below ₹500</a></li>
                    <li><a href="#" className="text-blue-600 hover:underline">📦 Holiday package confirmed</a></li>
                  </ul>
                </div>
              )}
            </div> */}
                  {user?.UserData?.user?.BNPLCreditStatus === 1 && (
                    <div className="relative">
                      <button className="flex items-center space-x-2 text-sm">
                        <span className="hidden sm:inline-block text-center">
                          <div className="flex items-center space-x-1">
                            <Wallet size={16} />
                            &nbsp;
                            <CurFt
                              currency={"INR"}
                              price={
                                newBNPLBalance > 0 ? newBNPLBalance : user?.UserData?.BNPL?.available_credit_sum || 0
                              }
                            />
                          </div>
                          <span className="text-blue-600 hover:underline block ">BNPL Wallet</span>
                        </span>
                      </button>
                    </div>
                  )}
                  <div className="relative">
                    <button className="flex items-center space-x-2 text-sm">
                      <span className="hidden sm:inline-block text-center">
                        {/* Wallet + Balance + Refresh in same row */}
                        <span className="text-[10px]">Credit + Wallet</span>
                        <div className="flex items-center space-x-1">
                          <Wallet size={16} />
                          &nbsp;
                          <CurFt
                            currency={"INR"}
                            price={newBalance > 0 ? newBalance : user?.UserData?.accountBalance}
                          />
                          <RotateCw
                            size={16}
                            onClick={handleRotate}
                            className={`cursor-pointer ${isRotating ? "animate-spin" : ""}`}
                          />
                        </div>
                        {/* Recharge link below */}
                        {segments[1] !== "review" && (
                          <a href="#" onClick={RechargeHand} className="text-blue-600 hover:underline block ">
                            Recharge
                          </a>
                        )}
                      </span>
                    </button>
                  </div>
                  {/* <div className="relative">
                    <button className="flex items-center space-x-2 text-sm">
                      <span className="hidden sm:inline-block text-center">
                        <span className="text-[14px]">ID: {user?.UserData?.id}</span>

                      </span>
                    </button>
                  </div> */}

                  {/* Profile */}
                  <div className="relative" onClick={(e) => e.stopPropagation()}>
                    <button
                      onClick={() => setShowProfile(!showProfile)}
                      className="flex items-center space-x-2 text-sm"
                    >

                      <span className="hidden sm:inline-block text-left">
                        {response?.UserData?.totalOutStanding > 0 && (
                          <span className="text-[12px] text-red-500" title="Your account will be deactivated after the due date.">DUES:
                            <CurFt
                              currency={"INR"}
                              price={response?.UserData?.totalOutStanding || 0}
                            />
                            {/* {(response?.UserData?.DueDate !== "" && response?.UserData?.DueDate !== null) && (
                              // <>
                              //   &nbsp;|&nbsp;{format(parseISO(response?.UserData?.DueDate), 'dd/MM/yyyy')}
                              // </>
                            )} */}

                          </span>
                        )}
                        <div className="flex items-center space-x-1">
                          <User size={16} />
                          <span className="hidden sm:inline-block">Hi, <TruncatedText text={user?.UserData?.user?.details?.agencyName} max={12} mode="end" /> </span>
                        </div>
                        <a href="#" className="text-blue-600 hover:underline block ">
                          ID: {user?.UserData?.id}
                        </a>
                      </span>

                    </button>
                    {showProfile && (
                      <div className="absolute right-0 mt-2 w-48 bg-white shadow-lg rounded-md py-2 z-50">
                        <Link onClick={closeDropdowns} to="/profile" className="block px-4 py-2 hover:bg-gray-100">
                          My Account
                        </Link>
                        <Link onClick={closeDropdowns} to="/setting" className="block px-4 py-2 hover:bg-gray-100">
                          Settings
                        </Link>
                        {user?.UserData?.user?.UserType == "6" && (
                          <Link to="/users" className="block px-4 py-2 hover:bg-gray-100">
                            Manage User
                          </Link>
                        )}
                        <Link onClick={() => {
                          closeDropdowns();
                          openRelationshipManager(); // another function
                        }} className="block px-4 py-2 hover:bg-gray-100">
                          Relationship Manager
                        </Link>
                        <a href="#" onClick={handleLogout} className="block px-4 py-2 text-red-600 hover:bg-gray-100">
                          Logout
                        </a>
                      </div>
                    )}
                  </div>

                  {/* Mobile menu toggle */}
                  <button onClick={() => setShowMobileMenu(!showMobileMenu)} className="md:hidden">
                    <svg className="h-6 w-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path d="M4 6h16M4 12h16M4 18h16" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            {/* Mobile Menu */}
            {showMobileMenu && (
              <div className="md:hidden px-4 pb-4 bg-white">
                {user?.UserData?.user?.agency?.flight_allowed === 1 && (
                  <Link
                    onClick={() => setShowMobileMenu(false)}
                    to="/flight"
                    className="block py-2 text-blue-600 font-semibold"
                  >
                    Flight
                  </Link>
                )}
                {user?.UserData?.user?.agency?.hotel_allowed === 1 && (
                  <Link
                    onClick={() => setShowMobileMenu(false)}
                    to="/hotel"
                    className="block py-2 font-semibold"
                  >
                    Hotel
                  </Link>
                )}
                {user?.UserData?.user?.agency?.holidays_allowed === 1 && (
                  <Link
                    onClick={() => setShowMobileMenu(false)}
                    to="/holidays"
                    className="block py-2 font-semibold"
                  >
                    Holidays
                  </Link>
                )}
                {getdomainName() === 'goertrip.club' && (
                  <Link
                    onClick={() => setShowMobileMenu(false)}
                    to="/umrah"
                    className="block py-2 font-semibold"
                  >
                    Umrah/Hajj
                  </Link>
                )}
                <div className="py-2">
                  <span className="block font-medium">Finance</span>
                  {financeMenu.map((item, idx) => (
                    <Link
                      key={idx}
                      to={item.path}
                      onClick={() => setShowMobileMenu(false)}
                      className="block pl-4 py-1 text-sm"
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
                <div className="py-2">
                  <span className="block font-medium">Report</span>
                  {reportMenu.map((item, idx) => (
                    <Link
                      key={idx}
                      to={item.path}
                      onClick={() => setShowMobileMenu(false)}
                      className="block pl-4 py-1 text-sm"
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
                {/* <Link onClick={() => setShowMobileMenu(false)} to="/booking-calendar" className="block py-2">Flight Tickets</Link> */}
                <hr className="my-2" />
                <div className="relative">
                  <button className="flex items-center space-x-2 text-sm">
                    <span className=" sm:inline-block text-left">
                      {/* Wallet + Balance + Refresh in same row */}
                      <span className="text-[10px]">Credit + Wallet</span>
                      <div className="flex items-center space-x-1">
                        <Wallet size={16} />
                        &nbsp;
                        <CurFt currency={"INR"} price={newBalance > 0 ? newBalance : user?.UserData?.accountBalance} />
                        <RotateCw
                          size={16}
                          onClick={handleRotate}
                          className={`cursor-pointer ${isRotating ? "animate-spin" : ""}`}
                        />
                      </div>

                      {/* Recharge link below */}
                      {segments[1] !== "review" && (
                        <a href="#" onClick={RechargeHand} className="text-blue-600 hover:underline block mt-1">
                          Recharge
                        </a>
                      )}
                    </span>

                    {user?.UserData?.user?.BNPLCreditStatus === 1 && (
                      <span className=" sm:inline-block text-left">
                        <div className="flex items-center space-x-1">
                          <Wallet size={16} />
                          &nbsp;
                          <CurFt
                            currency={"INR"}
                            price={
                              newBNPLBalance > 0 ? newBNPLBalance : user?.UserData?.BNPL?.available_credit_sum || 0
                            }
                          />
                        </div>
                        <span className="text-blue-600 hover:underline block ">BNPL Wallet</span>
                      </span>
                    )}
                  </button>
                </div>
                {response?.UserData?.totalOutStanding > 0 && (
                  <span className="text-[13px] text-red-500" title="Your account will be deactivated after the due date.">DUES:
                    <CurFt
                      currency={"INR"}
                      price={response?.UserData?.totalOutStanding || 0}
                    />
                    {(response?.UserData?.DueDate !== "" && response?.UserData?.DueDate !== null) && (
                      <>
                        &nbsp;|&nbsp;{format(parseISO(response?.UserData?.DueDate), 'dd/MM/yyyy')}
                      </>
                    )}
                  </span>
                )}

                <span className="block py-1">Hi, {user?.UserData?.user?.details?.agencyName} (ID: {user?.UserData?.id})</span>
                <Link onClick={() => setShowMobileMenu(false)} to="/profile" className="block py-2 hover:bg-gray-100">
                  My Account
                </Link>
                <Link onClick={setShowMobileMenu} to="/setting" className="block py-2 hover:bg-gray-100">
                  Settings
                </Link>
                {user?.UserData?.user?.UserType == "6" && (
                  <Link to="/users" className="block py-2 hover:bg-gray-100">
                    Manage User
                  </Link>
                )}
                <Link onClick={() => {
                  setShowMobileMenu();
                  openRelationshipManager(); // another function
                }} className="block py-2 ">
                  Relationship Manager
                </Link>
                <Link onClick={handleLogout} className="block py-2 text-red-600">
                  Logout
                </Link>

              </div>
            )}

            {logoutstatus === "pendig" && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                <div className="bg-white p-6 rounded-xl shadow-lg w-80 text-center">
                  <h2 className="text-lg font-semibold mb-4">Please wait....</h2>
                  <p className="text-sm text-gray-600 mb-6">Logging Out</p>
                </div>
              </div>
            )}
          </header>

          <Dialog
            open={isSectorModalOpen}
            onClose={() => setIsModalSector(false)}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          >
            <div className="bg-white w-full max-w-lg rounded-2xl shadow-lg p-6">
              {/* Header Row */}
              <div className="flex items-center justify-between w-full border-b pb-2 mb-4">
                <h2 className="text-lg font-semibold">Make Deposit</h2>
                <button onClick={() => setIsModalSector(false)} className="text-gray-500 hover:text-gray-700">
                  <X size={20} />
                </button>
              </div>

              {/* Form */}
              <form className="space-y-4" onSubmit={handleSubmit}>
                <p className="text-red-500">{DueClearMessage}</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* Payment Mode */}
                  <div className="flex flex-col">
                    <label className="text-sm font-medium mb-1">Payment Mode</label>
                    <select
                      name="PaymentMode"
                      value={formData.PaymentMode}
                      onChange={handleChange}
                      className="w-full border rounded-lg px-3 py-2"
                    >
                      {paymentmode.map((item, key) => (
                        <option key={key} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Amount */}
                  <div className="flex flex-col">
                    <label className="text-sm font-medium mb-1">Amount</label>
                    <input
                      type="number"
                      name="amount"
                      value={formData.amount}
                      onChange={handleChange}
                      // onInput={handleInput}
                      placeholder="eg-5000"
                      className="w-full border rounded-lg px-3 py-2 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                      style={{
                        MozAppearance: "textfield",
                      }}
                    />
                  </div>

                  {/* Reference No */}
                  <div className="flex flex-col">
                    <label className="text-sm font-medium mb-1">Reference No</label>
                    <input
                      type="text"
                      name="referenceno"
                      value={formData.referenceno}
                      onChange={handleChange}
                      placeholder="eg-12548755"
                      className="w-full border rounded-lg px-3 py-2"
                    />
                  </div>

                  {/* Deposit Date */}
                  <div className="flex flex-col">
                    <label className="text-sm font-medium mb-1">Deposit Date</label>
                    <DateInput
                      placeholder="dd-mm-yyyy"
                      valueFormat="DD-MM-YYYY"
                      maxDate={new Date()} // min date = today
                      value={formData.date}
                      onChange={(date) => handleChange("date", date)}
                      rightSection={<Calendar size={18} className="text-gray-500" />} // 👈 custom calendar icon
                      classNames={{
                        input: "w-full !border !rounded-lg !px-3 !py-2 p-6 ",
                      }}
                    />
                  </div>
                </div>

                {/* Remarks */}
                {formData.PaymentMode !== "Make Online" && (
                  <div className="flex flex-col">
                    <label className="text-sm font-medium mb-1">Upload Receipt (Recommend max size. 5MB)</label>
                    <div>
                      <label className="cursor-pointer bg-gray-100 px-4 py-2 rounded-lg border inline-block">
                        Upload Receipt
                        <input
                          type="file"
                          className="hidden"
                          accept=".jpg,.jpeg,.png,.pdf"
                          onChange={handlePhotoChange}
                        />
                      </label>

                      {/* Show selected file name */}
                      {fileName && (
                        <div className="flex items-center gap-3 mt-2">
                          <p className="text-sm text-gray-600">
                            Selected File: <span className="font-medium">{fileName}</span>
                          </p>

                          <button
                            type="button"
                            onClick={handleRemoveFile}
                            className="text-red-500 text-sm hover:underline"
                          >
                            Remove
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <div className="flex flex-col">
                  <label className="text-sm font-medium mb-1">Remarks</label>
                  <textarea
                    name="remarks"
                    value={formData.remarks}
                    onChange={handleChange}
                    placeholder="eg- bank name, Transaction ID, cheque number, branch address...."
                    rows={3}
                    className="w-full border rounded-lg px-3 py-2"
                  />
                </div>

                {/* Submit */}
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={loading === true}
                    className={`bg-blue-500 text-white px-5 py-2 rounded-md hover:blue-600 transition ${loading === true ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"
                      }`}
                  >
                    {loading === true ? <>Please wait...</> : <>Submit</>}
                  </button>
                </div>
              </form>
            </div>
          </Dialog>
        </>
      ) : (
        <>
          <header className="sticky top-0 z-50 bg-white shadow-md">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
              {/* Logo */}
              <div className="flex items-center gap-2">
                <Link to="/">
                  <img src={"/" + getSiteName() + "/logo.png"} alt="Logo" className="h-10" />
                </Link>
              </div>

              {/* Desktop nav */}
              <nav className="hidden lg:flex items-center gap-6 text-sm font-medium text-slate-600">
                <a
                  href="/"
                  className="hover:text-blue-600 transition-colors duration-200 whitespace-nowrap"
                >
                  Home
                </a>
                <a
                  href="/cms/about-us"
                  className="hover:text-blue-600 transition-colors duration-200 whitespace-nowrap"
                >
                  About Us
                </a>
                <a
                  href="/cms/contact-us"
                  className="hover:text-blue-600 transition-colors duration-200 whitespace-nowrap"
                >
                  Contact Us
                </a>
              </nav>
              <nav className="hidden lg:flex items-tight gap-2 text-sm font-medium text-slate-600">
                <a
                  href={"/register"}
                  className="hidden lg:inline-flex items-center gap-1 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-5 py-2 rounded-full transition-colors duration-200 shadow"
                >
                  SIGNUP
                </a>
                <a
                  href={"/login"}
                  className="hidden lg:inline-flex items-center gap-1 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-5 py-2 rounded-full transition-colors duration-200 shadow"
                >
                  LOGIN
                </a>
              </nav>



              {/* Hamburger */}
              <button
                className="lg:hidden p-2 rounded-md text-slate-600 hover:bg-blue-50"
                onClick={() => setMobileOpen(!mobileOpen)}
              >
                <span className="sr-only">Menu</span>
                <div className="space-y-1.5">
                  <span className="block w-6 h-0.5 bg-current" />
                  <span className="block w-6 h-0.5 bg-current" />
                  <span className="block w-6 h-0.5 bg-current" />
                </div>
              </button>
            </div>

            {/* Mobile menu */}
            {mobileOpen && (
              <div className="lg:hidden bg-white border-t border-blue-100 px-4 pb-4">
                <a href="/" className="block py-2 text-sm font-medium text-slate-700 hover:text-blue-600">
                  Home
                </a>
                <a href="/cms/about-us" className="block py-2 text-sm font-medium text-slate-700 hover:text-blue-600">
                  About Us
                </a>
                <a href="/cms/contact-us" className="block py-2 text-sm font-medium text-slate-700 hover:text-blue-600">
                  Contact Us
                </a>
                <a
                  href={"/register"}
                  className="mt-3 inline-block bg-blue-600 text-white text-sm font-semibold px-5 py-2 rounded-full"
                >
                  SIGNUP
                </a>
                <a
                  href={"/login"}
                  className="mt-3 inline-block bg-blue-600 text-white text-sm font-semibold px-5 py-2 rounded-full"
                >
                  LOGIN
                </a>
              </div>
            )}
          </header>
          {/* <header className="flex justify-between items-center px-8 py-4 border-b bg-white sticky top-0 z-50">
            <div>
              <Link to="/">
                <img src={"/" + getSiteName() + "/logo.png"} alt="Logo" className="h-10" />
              </Link>
            </div>
            <nav className="flex items-center space-x-6">
              <a href="/cms/about-us" className="text-gray-700 hover:text-black">
                About Us
              </a>
              <a href="/cms/contact-us" className="text-gray-700 hover:text-black">
                Contact Us
              </a>
              
              <a
                className="px-4 py-1 rounded-full bg-cyan-600 text-white hover:bg-blue-700 transition"
                href={"/login"}
              >
                Login
              </a>
              <a
                className="px-4 py-1 rounded-full bg-blue-600 text-white hover:bg-blue-700 transition"
                href={"/register"}
              >
                Registration
              </a>

            </nav>
          </header> */}
        </>
      )}

      {user?.UserData && (
        <Link
          to="/ticket"
          className="
        fixed
        bottom-2
        right-6
        z-50
        flex
        items-center
        gap-2
        rounded-full
        bg-blue-600
        px-5
        py-3
        text-sm
        font-semibold
        text-white
        shadow-lg
        transition
        hover:bg-blue-700
        hover:shadow-xl
        active:scale-95
        animate-pulse
      "
        >
          🎫 Raise Ticket
        </Link>
      )}
    </>
  );
};

export default Navbar;
